export const cnpjCpfToString = (value: string) => {
  const normalizedValue = value?.replace(/\D/g, '')

  if (!normalizedValue) return value

  return value.replaceAll('.', '').replaceAll('-', '').replaceAll('/', '')
}

export const maskToString = (value: string) => {
  const normalizedValue = value?.replace(/\D/g, '')

  if (!normalizedValue) return value

  return value
    .replaceAll('.', '')
    .replaceAll('-', '')
    .replaceAll('/', '')
    .replaceAll(' ', '')
    .replaceAll('(', '')
    .replaceAll(')', '')
}
